import { diffChars, diffSentences, diffWords } from 'diff';
import * as React from 'react';
import { Button } from './button/Button';
import { AnimatedCollapsibleContent } from './collapsible/AnimatedCollapsibleContent';
import { colors } from './colors/color';
import { Flex } from './compositeComponents/FlexHelpers';
import { Icon } from './icons/Icons';

type FieldChangePanelProps = {
    defaultOpen?:boolean,
    children:React.ReactNode
}
export function FieldChangePanel(props:FieldChangePanelProps):JSX.Element
{
    const [open, setOpen] = React.useState(props.defaultOpen || false);

    function handleClickToggle()
    {
        setOpen(!open);
    }

    return (
        <div>
            <Flex alignItems='center'>
                <Flex style={{flexGrow:1}} alignItems='center'>
                    <Icon name='priority' color={colors.icon.warning} />
                    <span>indeholder ændringer</span>
                </Flex>
                <Button variant='text' text='' icon={open ? 'caret_caretUp' : 'caret_caretDown'} onClick={handleClickToggle} />
            </Flex>
            <AnimatedCollapsibleContent open={open}>
                {props.children}
            </AnimatedCollapsibleContent>
        </div>
    );
}


type SimpleFieldChangePanelProps = {
    oldValue:string,
    newValue:string,
    defaultOpen?:boolean
}
export function SimpleFieldChangePanel(props:SimpleFieldChangePanelProps):JSX.Element
{
    return (
        <>
            {props.oldValue !== props.newValue &&
                <FieldChangePanel defaultOpen={props.defaultOpen}>
                    <s>{props.oldValue || '*ingen værdi*' }</s> er ændret til <b>{props.newValue || '*ingen værdi*'}</b>
                </FieldChangePanel>
            }
        </>
    );
}


type TextFieldChangePanelProps = {
    oldText:string,
    newText:string,
    diffMode?: 'characters' | 'words' | 'sentences',
    defaultOpen?:boolean
}
export function TextFieldChangePanel(props:TextFieldChangePanelProps):JSX.Element
{
    let changes = []
    if(props.diffMode === 'characters')
        changes = diffChars(props.oldText, props.newText);
    else if(props.diffMode === 'words')
        changes = diffWords(props.oldText, props.newText);
    else 
        changes = diffSentences(props.oldText, props.newText);

    let __html = '';
    for(let i=0; i<changes.length; i++)
    {
        const change = changes[i];
        if(change.added)
            __html += `<b>${change.value}</b>`;
        else if(change.removed)
            __html += `<s>${change.value}</s>`;
        else
            __html += change.value;
    }
    return (
        <>
            {changes.some(c => c.added || c.removed) &&
                <FieldChangePanel defaultOpen={props.defaultOpen}>
                    <div dangerouslySetInnerHTML={{__html}}></div>
                </FieldChangePanel>
            }
        </>
    );
}